import React from "react";
import { ShieldCheck, Heart, Sparkles, Users } from "lucide-react";

const features = [
  {
    icon: ShieldCheck,
    title: "Trusted Quality",
    desc: "Every product carefully selected — fresh, genuine and reliable.",
    testid: "why-quality",
  },
  {
    icon: Heart,
    title: "Affordable Prices",
    desc: "Best rates for quality goods — perfectly fitting your family budget.",
    testid: "why-price",
  },
  {
    icon: Sparkles,
    title: "Everything in One Place",
    desc: "From grocery to gifts — all daily essentials under one roof.",
    testid: "why-variety",
  },
  {
    icon: Users,
    title: "Friendly Service",
    desc: "For the people of Partur, by the people of Partur — with warmth and respect.",
    testid: "why-service",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="py-20 sm:py-28 bg-white relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute top-1/2 -right-40 w-[500px] h-[500px] rounded-full bg-[#F5EFE0] blur-3xl opacity-50"
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="font-latin text-xs uppercase tracking-[0.3em] text-[#9B8B3E] mb-3">
              Why R Maart
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#1A1813] leading-tight">
              Why <span className="text-[#9B8B3E] italic">choose us?</span>
            </h2>
            <p className="mt-5 text-[#5C5646] text-base sm:text-lg leading-relaxed font-latin">
              R Maart isn't just a store — it's part of the Partur family.
              We bring together quality, trust and warmth, all under one roof.
            </p>

            <div className="mt-8 inline-flex items-center gap-4 bg-[#FBF9F6] border border-[#E5E1D5] rounded-2xl px-5 py-4">
              <div className="w-12 h-12 rounded-xl bg-[#9B8B3E] text-white flex items-center justify-center font-display text-xl font-semibold">
                R
              </div>
              <div>
                <div className="font-display text-lg text-[#1A1813] font-semibold">
                  R Maart
                </div>
                <div className="text-xs text-[#5C5646] font-latin">
                  Partur's trusted supermart
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-5">
              {features.map((f) => (
                <FeatureCard key={f.title} {...f} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FeatureCard({ icon: Icon, title, desc, testid }) {
  return (
    <div
      data-testid={testid}
      className="group bg-white border border-[#E5E1D5] rounded-2xl p-6 hover:border-[#9B8B3E]/40 hover:shadow-[0_12px_40px_rgba(155,139,62,0.08)] transition-all duration-500"
    >
      <div className="w-12 h-12 rounded-xl bg-[#F5EFE0] text-[#9B8B3E] flex items-center justify-center mb-5 group-hover:bg-[#9B8B3E] group-hover:text-white transition-colors">
        <Icon className="w-5 h-5" strokeWidth={1.75} />
      </div>
      <h3 className="font-display text-xl text-[#1A1813] mb-2 font-semibold">
        {title}
      </h3>
      <p className="text-sm text-[#5C5646] leading-relaxed font-latin">{desc}</p>
    </div>
  );
}
